import {
  DEMO_CLIENT_IDS,
  DEMO_RG_SOPHIE,
  DEMO_RG_MARIE,
  DEMO_RG_THOMAS,
  DEMO_SESSION_IDS as DS,
  DEMO_CAL_EVENT_IDS as DE,
  DEMO_FIN_MARCH_DONE_IDS,
  DEMO_DEMOPLAN_EVENT_IDS,
} from "./demoEntityIds";
import { DEMO_PRODUCT_IDS } from "./products";

export { INIT_PRODUCTS, DEMO_PRODUCT_IDS } from "./products";

export {
  DEF_THEME,
  BG_PRESETS,
  SETTINGS_BG_PRESETS,
  ACCENT_PRESETS,
  COLOR_ACCENT_DEFAULT,
  COLOR_BG_DEFAULT,
  CLIENT_STATUS_COLORS,
} from "./colors";

export { DURATION_PRESETS, DEFAULT_SESSION_DURATION } from "./durations";

export { CLIENT_STATUSES, BILLING_MODES, EVENT_STATUS } from "./statuses";

export { SETTINGS_TABS } from "./labels";

export const STORE_KEY = "atelier_v1";

export const DAYS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

export const DEFAULT_TARIF = 60;

export const SLOTS = Array.from({ length: 36 }, (_, i) => {
  const h = 6 + Math.floor(i / 2);
  const m = i % 2 === 0 ? "00" : "30";
  return `${String(h).padStart(2, "0")}:${m}`;
});

export const DEF_SCHED = Object.fromEntries(
  DAYS.map((d, di) => [
    d,
    di < 5
      ? SLOTS.filter((s) => {
          const h = parseInt(s);
          return (h >= 7 && h < 13) || (h >= 15 && h < 20);
        })
      : di === 5
        ? SLOTS.filter((s) => parseInt(s) >= 9 && parseInt(s) < 13)
        : [],
  ]),
);

export const DEFAULT_LOGO_URL = "/athleos-logo-default.png";

export const DEFAULT_EQUIP = {
  bodyweight: true,
  dumbbells: true,
  kettlebells: false,
  barbell: false,
  bands: true,
  machines: false,
  trx: false,
  cardioMachines: false,
  cardioTapis: false,
  cardioVelo: false,
  cardioRameur: false,
  cardioSkiErg: false,
  cardioStep: false,
  custom: [],
};

function _frMonthDay(year, month0, day) {
  return new Date(year, month0, day).toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/** Année des séances démo (sessions FR + événements ISO calendrier alignés). */
const DEMO_DATA_YEAR = new Date().getFullYear();

const _SUB_PRORATA_3 = Number((250 / 3).toFixed(2));

function _demoSession(month0, day, opts = {}) {
  const {
    id,
    duration = 60,
    status = "done",
    billableAmount,
    summary = "",
    exercises = [],
    title,
    hasDebrief,
  } = opts;
  const dateIso = `${DEMO_DATA_YEAR}-${String(month0 + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  const row = {
    id: id ?? `demo-${DEMO_DATA_YEAR}-m${month0}-d${day}-${status}-${duration}`,
    date: _frMonthDay(DEMO_DATA_YEAR, month0, day),
    dateIso,
    duration,
    status,
    aiSummary: summary,
    exercises,
  };
  if (title != null) row.title = title;
  if (hasDebrief != null) row.hasDebrief = hasDebrief;
  if (billableAmount != null) row.billableAmount = billableAmount;
  return row;
}

export const INIT_CLIENTS = [
  {
    id: DEMO_CLIENT_IDS[0],
    firstName: "Sophie",
    name: "Sophie Martin",
    age: 34,
    emoji: "👩‍🦰",
    status: "active",
    objective: "Perte de poids et tonification générale",
    constraints: "Douleur chronique genou gauche",
    disponibilites: "Lun Mer Ven 7h-9h",
    niveau: "Intermédiaire",
    preferences: "Déteste les burpees. Aime le HIIT et le renforcement.",
    email: "sophie.martin@email.com",
    phone: "06 98 76 54 32",
    birth_date: "1992-07-15",
    gender: "F",
    urssaf: false,
    billingMode: "session",
    productId: DEMO_PRODUCT_IDS.session,
    productInstance: {
      startDate: `${DEMO_DATA_YEAR}-01-10`,
      sessionsUsed: 0,
      sessionsTotal: null,
      expiresAt: null,
      status: "active",
      renewalDate: null,
    },
    aiSummary:
      "Sophie progresse bien en renforcement. Attention au genou gauche sur les squats profonds. Charge moyenne en hausse de 12 %. Bonne régularité (3×/semaine).",
    aiSummaryDate: "2026-03-29T10:00:00.000Z",
    cancelCount: 1,
    tags: [],
    clientNotes: [
      {
        id: "note-demo-sophie-1",
        coachId: null,
        clientId: DEMO_CLIENT_IDS[0],
        type: "debrief",
        content:
          "Bonne séance, Sophie a bien progressé sur le hip thrust. Genou un peu sensible en fin de séance.",
        rating: 6,
        chips: [{ label: "Douleur signalée", variant: "warning" }],
        sourceSessionId: DS.sophie3,
        createdAt: "2026-03-28T15:20:00.000Z",
        updatedAt: "2026-03-28T15:20:00.000Z",
      },
      {
        id: "note-demo-sophie-2",
        clientId: DEMO_CLIENT_IDS[0],
        type: "note",
        content: "Sophie part en vacances du 5 au 12 avril. Prévoir reprise en douceur.",
        rating: null,
        chips: [],
        sourceSessionId: null,
        createdAt: "2026-03-26T09:45:00.000Z",
        updatedAt: "2026-03-26T09:45:00.000Z",
      },
      {
        id: "note-demo-sophie-3",
        clientId: DEMO_CLIENT_IDS[0],
        type: "debrief",
        content: "Séance tranquille, pas de douleur. +2kg sur le squat goblet.",
        rating: 4,
        chips: [{ label: "RAS", variant: "neutral" }],
        sourceSessionId: DS.sophie1,
        createdAt: "2026-03-25T16:10:00.000Z",
        updatedAt: "2026-03-25T16:10:00.000Z",
      },
      {
        id: "note-demo-sophie-4",
        clientId: DEMO_CLIENT_IDS[0],
        type: "note",
        content: "Premier bilan. Hernie L4-L5 en 2024, kiné OK pour reprise progressive.",
        rating: null,
        chips: [],
        sourceSessionId: null,
        createdAt: "2026-03-20T10:00:00.000Z",
        updatedAt: "2026-03-20T10:00:00.000Z",
      },
      {
        id: "note-demo-sophie-5",
        clientId: DEMO_CLIENT_IDS[0],
        type: "note",
        content: "Appel découverte. Sophie cherche un coach pour reprendre le sport.",
        rating: null,
        chips: [],
        sourceSessionId: null,
        createdAt: "2026-02-15T11:30:00.000Z",
        updatedAt: "2026-02-15T11:30:00.000Z",
      },
    ],
    sessions: [
      _demoSession(2, 1, {
        id: DS.sophie1,
        duration: 55,
        billableAmount: 60,
        title: "Full Body Mobilité",
        summary: "Échauffement articulaire, bases renfo.",
        hasDebrief: true,
        exercises: [
          { name: "Goblet squat", sets: 3, reps: 12, weight: 14, mode: "reps", rest: 75 },
          { name: "Hip thrust", sets: 4, reps: 10, weight: 36, mode: "reps", rest: 90 },
          { name: "Gainage latéral", sets: 3, reps: 0, duration: 40, weight: 0, mode: "chrono", rest: 45 },
        ],
      }),
      _demoSession(2, 12, {
        id: DS.sophie2,
        duration: 50,
        billableAmount: 60,
        title: "Upper Push + Core",
        summary: "Volume buste, finisher abdos.",
        hasDebrief: true,
        exercises: [
          { name: "Presse inclinée haltères", sets: 4, reps: 10, weight: 12, mode: "reps", rest: 90 },
          { name: "Élévations latérales", sets: 3, reps: 15, weight: 6, mode: "reps", rest: 60 },
          { name: "Crunch poulie", sets: 3, reps: 15, weight: 25, mode: "reps", rest: 45 },
        ],
      }),
      _demoSession(2, 18, {
        id: DS.sophie3,
        duration: 55,
        billableAmount: 60,
        title: "Lower Body Force",
        summary: "Cuisses lourdes, variantes genou.",
        hasDebrief: false,
        exercises: [
          { name: "Presse à cuisses", sets: 4, reps: 12, weight: 40, mode: "reps", rest: 100 },
          { name: "Fentes bulgares", sets: 3, reps: 10, weight: 8, mode: "reps", rest: 90 },
          { name: "Leg curl allongé", sets: 3, reps: 12, weight: 22, mode: "reps", rest: 60 },
        ],
      }),
      _demoSession(2, 21, { id: DS.sophieCxl, duration: 50, status: "cancelled", title: "Séance annulée", summary: "Annulée." }),
      {
        id: DS.sophiePlanned,
        date: "Prochaine séance",
        duration: 60,
        status: "planned",
        title: "HIIT contrôlé",
        aiSummary: "Fractionné bike + renforcement doux, sans burpees.",
        exercises: [
          { name: "Bike intervals", sets: 6, reps: 0, duration: 45, weight: 0, mode: "chrono", rest: 90 },
          { name: "Kettlebell swing léger", sets: 3, reps: 12, weight: 12, mode: "reps", rest: 60 },
          { name: "Pallof press", sets: 3, reps: 12, weight: 10, mode: "reps", rest: 45 },
        ],
      },
    ],
  },
  {
    id: DEMO_CLIENT_IDS[1],
    firstName: "Thomas",
    name: "Thomas Dubois",
    age: 29,
    emoji: "🏋️",
    status: "active",
    billingMode: "pack",
    productId: DEMO_PRODUCT_IDS.pack,
    productInstance: {
      startDate: `${DEMO_DATA_YEAR}-02-15`,
      packAssignedAt: `${DEMO_DATA_YEAR}-02-15T12:00:00.000Z`,
      sessionsUsed: 4,
      sessionsTotal: 10,
      expiresAt: null,
      status: "active",
      renewalDate: null,
    },
    objective: "Prise de masse musculaire",
    constraints: "Risque surmenage. Épaule droite fragile.",
    disponibilites: "Mar Jeu Sam 18h-20h",
    niveau: "Avancé",
    preferences: "Aime le lourd. Préfère les séances de 60 min.",
    email: "thomas.dubois@email.com",
    phone: "06 12 34 56 78",
    birth_date: "1997-03-22",
    gender: "M",
    aiSummary:
      "Thomas progresse bien en force. Attention épaule droite sur le développé. Charge en hausse régulière. Très motivé, tendance au surmenage.",
    aiSummaryDate: "2026-03-29T10:00:00.000Z",
    cancelCount: 0,
    tags: [],
    clientNotes: [
      {
        id: "note-demo-thomas-1",
        coachId: null,
        clientId: DEMO_CLIENT_IDS[1],
        type: "debrief",
        content: "Pull day costaud — tirage prise neutre OK, pas de tirage douloureux à l’épaule droite.",
        rating: 7,
        chips: [{ label: "Bonne séance", variant: "neutral" }],
        sourceSessionId: DS.thomas5,
        createdAt: "2026-03-27T19:00:00.000Z",
        updatedAt: "2026-03-27T19:00:00.000Z",
      },
      {
        id: "note-demo-thomas-2",
        coachId: null,
        clientId: DEMO_CLIENT_IDS[1],
        type: "debrief",
        content: "Leg day un peu juste en récup — il a mal dormi, on a réduit les charges sur le squat.",
        rating: 5,
        chips: [{ label: "Fatigue", variant: "warning" }],
        sourceSessionId: DS.thomas6,
        createdAt: "2026-03-29T11:15:00.000Z",
        updatedAt: "2026-03-29T11:15:00.000Z",
      },
      {
        id: "note-demo-thomas-3",
        clientId: DEMO_CLIENT_IDS[1],
        type: "note",
        content: "Prévoir variantes d’épaule (prise serrée, tempo) si douleur au développé persiste.",
        rating: null,
        chips: [],
        sourceSessionId: null,
        createdAt: "2026-03-20T08:30:00.000Z",
        updatedAt: "2026-03-20T08:30:00.000Z",
      },
    ],
    sessions: [
      _demoSession(2, 2, {
        id: DS.thomas1,
        duration: 60,
        billableAmount: 50,
        title: "Push Day",
        summary: "Buste — développé et accessoires.",
        hasDebrief: false,
        exercises: [
          { name: "Développé couché", sets: 4, reps: 8, weight: 70, mode: "reps", rest: 120 },
          { name: "Développé incliné haltères", sets: 3, reps: 10, weight: 22, mode: "reps", rest: 90 },
          { name: "Extension triceps poulie", sets: 3, reps: 12, weight: 25, mode: "reps", rest: 60 },
        ],
      }),
      _demoSession(2, 4, {
        id: DS.thomas2,
        duration: 60,
        billableAmount: 50,
        title: "Pull Day",
        summary: "Dos — tirages et rowing.",
        hasDebrief: false,
        exercises: [
          { name: "Tirage vertical", sets: 4, reps: 10, weight: 55, mode: "reps", rest: 90 },
          { name: "Rowing barre", sets: 4, reps: 8, weight: 60, mode: "reps", rest: 90 },
          { name: "Curl barre", sets: 3, reps: 10, weight: 35, mode: "reps", rest: 60 },
        ],
      }),
      _demoSession(2, 8, {
        id: DS.thomas3,
        duration: 60,
        billableAmount: 50,
        title: "Leg Day",
        summary: "Cuisses et fessiers lourds.",
        hasDebrief: false,
        exercises: [
          { name: "Squat avant", sets: 4, reps: 8, weight: 100, mode: "reps", rest: 120 },
          { name: "Presse à cuisses", sets: 3, reps: 12, weight: 140, mode: "reps", rest: 90 },
          { name: "Leg curl", sets: 3, reps: 12, weight: 45, mode: "reps", rest: 60 },
        ],
      }),
      _demoSession(2, 10, {
        id: DS.thomas4,
        duration: 60,
        billableAmount: 50,
        title: "Push Day",
        summary: "Progression banc.",
        hasDebrief: false,
        exercises: [
          { name: "Développé couché", sets: 4, reps: 8, weight: 75, mode: "reps", rest: 120 },
          { name: "Écarté incliné", sets: 3, reps: 12, weight: 14, mode: "reps", rest: 75 },
          { name: "Dips lestés", sets: 3, reps: 8, weight: 10, mode: "reps", rest: 90 },
        ],
      }),
      _demoSession(2, 13, {
        id: DS.thomas5,
        duration: 60,
        billableAmount: 50,
        title: "Pull Day",
        summary: "Volume dos.",
        hasDebrief: true,
        exercises: [
          { name: "Tirage horizontal", sets: 4, reps: 10, weight: 50, mode: "reps", rest: 90 },
          { name: "Tirage poulie basse", sets: 3, reps: 12, weight: 45, mode: "reps", rest: 75 },
          { name: "Face pull", sets: 3, reps: 15, weight: 20, mode: "reps", rest: 45 },
        ],
      }),
      _demoSession(2, 15, {
        id: DS.thomas6,
        duration: 60,
        billableAmount: 50,
        title: "Leg Day — finisher buste",
        summary: "Jambes + un peu de volume épaules contrôlé.",
        hasDebrief: true,
        exercises: [
          { name: "Squat à machine (pendulum)", sets: 4, reps: 10, weight: 80, mode: "reps", rest: 100 },
          { name: "Fentes marchées", sets: 3, reps: 12, weight: 16, mode: "reps", rest: 75 },
          { name: "Développé couché", sets: 3, reps: 6, weight: 80, mode: "reps", rest: 120 },
        ],
      }),
    ],
  },
  {
    id: DEMO_CLIENT_IDS[2],
    firstName: "Marie",
    name: "Marie Leclerc",
    age: 52,
    emoji: "🌸",
    status: "active",
    billingMode: "subscription",
    productId: DEMO_PRODUCT_IDS.subscription,
    productInstance: {
      startDate: `${DEMO_DATA_YEAR}-02-01`,
      sessionsUsed: 0,
      sessionsTotal: 4,
      expiresAt: null,
      status: "active",
      renewalDate: null,
    },
    objective: "Mobilité et prévention ostéoporose",
    constraints: "Tension artérielle.",
    disponibilites: "Lun Mer 10h-12h",
    niveau: "Débutant",
    preferences: "Exercices au sol.",
    email: "marie.leclerc@email.com",
    phone: "06 55 44 33 22",
    birth_date: "1974-11-08",
    gender: "F",
    cancelCount: 1,
    tags: [],
    sessions: [
      _demoSession(2, 6, { id: DS.marie1, duration: 45, billableAmount: _SUB_PRORATA_3, summary: "Mobilité." }),
      _demoSession(2, 9, { id: DS.marie2, duration: 45, billableAmount: _SUB_PRORATA_3, summary: "Étirements." }),
      _demoSession(2, 14, { id: DS.marie3, duration: 45, billableAmount: _SUB_PRORATA_3, summary: "Renforcement léger." }),
      _demoSession(2, 17, { id: DS.marie4, duration: 45, billableAmount: _SUB_PRORATA_3, summary: "Sol." }),
    ],
  },
  {
    id: DEMO_CLIENT_IDS[3],
    name: "Karim Benzari",
    age: 41,
    emoji: "🧘",
    status: "active",
    objective: "Remise en forme post burn-out",
    constraints: "Stress élevé.",
    disponibilites: "Mer Ven 12h-13h30",
    niveau: "Débutant",
    preferences: "Séances courtes.",
    cancelCount: 0,
    tags: [],
    sessions: [
      _demoSession(2, 3, { id: DS.karim1, duration: 40, billableAmount: 60, summary: "Anti-stress." }),
      _demoSession(2, 11, { id: DS.karim2, duration: 35, billableAmount: 60, summary: "Cardio léger." }),
      _demoSession(2, 16, { id: DS.karim3, duration: 40, billableAmount: 60, summary: "Fonctionnel." }),
      _demoSession(2, 17, { id: DS.karim4, duration: 35, billableAmount: 60, summary: "Gainage." }),
      _demoSession(2, 19, { id: DS.karim5, duration: 40, billableAmount: 60, summary: "Marche active." }),
    ],
  },
  {
    id: DEMO_CLIENT_IDS[4],
    name: "Lucas Moreau",
    age: 32,
    emoji: "🚴",
    status: "active",
    billingMode: "pack",
    pack: { total: 10, used: 4 },
    objective: "Endurance et VMA",
    constraints: "",
    disponibilites: "Mar jeu 7h",
    niveau: "Intermédiaire",
    preferences: "Fractionné vélo.",
    cancelCount: 0,
    tags: [],
    sessions: [
      _demoSession(2, 8, { id: DS.lucas1, duration: 50, billableAmount: 50, summary: "Pack — fractionné." }),
      _demoSession(2, 12, { id: DS.lucas2, duration: 50, billableAmount: 50, summary: "Pack — endurance." }),
      _demoSession(2, 16, { id: DS.lucas3, duration: 50, billableAmount: 50, summary: "Pack — VMA." }),
      _demoSession(2, 20, { id: DS.lucas4, duration: 50, billableAmount: 50, summary: "Pack — récup active." }),
    ],
  },
  {
    id: DEMO_CLIENT_IDS[5],
    name: "Julie Petit",
    age: 28,
    emoji: "✨",
    status: "active",
    billingMode: "subscription",
    objective: "Suivi mensuel régulier",
    constraints: "",
    disponibilites: "Ven 18h30",
    niveau: "Intermédiaire",
    preferences: "Circuit complet.",
    cancelCount: 0,
    tags: [],
    sessions: [
      _demoSession(2, 4, { id: DS.julie1, duration: 50, billableAmount: _SUB_PRORATA_3, summary: "Abo — séance 1." }),
      _demoSession(2, 13, { id: DS.julie2, duration: 50, billableAmount: _SUB_PRORATA_3, summary: "Abo — séance 2." }),
      _demoSession(2, 19, { id: DS.julie3, duration: 50, billableAmount: _SUB_PRORATA_3, summary: "Abo — séance 3." }),
    ],
  },
  {
    id: DEMO_CLIENT_IDS[6],
    name: "Antoine Girard",
    age: 45,
    emoji: "🏃",
    status: "active",
    billingMode: "programme",
    objective: "Remise en forme progressive",
    constraints: "",
    disponibilites: "Lun Mer 18h",
    niveau: "Intermédiaire",
    preferences: "Cardio modéré.",
    cancelCount: 0,
    tags: [],
    productId: DEMO_PRODUCT_IDS.programme,
    productInstance: {
      startDate: `${DEMO_DATA_YEAR}-02-15`,
      sessionsUsed: 3,
      sessionsTotal: 8,
      expiresAt: null,
      status: "active",
      renewalDate: null,
    },
    sessions: [
      _demoSession(1, 18, {
        id: DS.antoineFeb,
        duration: 50,
        billableAmount: 60,
        summary: "Février — démarrage programme.",
        exercises: [{ name: "Marche inclinée", sets: 3, reps: 12, weight: 0, rest: 60, mode: "reps" }],
      }),
      _demoSession(2, 7, {
        id: DS.antoineM1,
        duration: 55,
        billableAmount: 60,
        summary: "Mars — séance 1.",
        exercises: [{ name: "Squat poids du corps", sets: 3, reps: 12, weight: 0, rest: 75, mode: "reps" }],
      }),
      _demoSession(2, 15, {
        id: DS.antoineM2,
        duration: 50,
        billableAmount: 60,
        summary: "Mars — séance 2.",
        exercises: [{ name: "Fentes", sets: 3, reps: 10, weight: 0, rest: 60, mode: "reps" }],
      }),
      _demoSession(2, 23, {
        id: DS.antoineM3,
        duration: 50,
        billableAmount: 60,
        summary: "Mars — séance 3.",
        exercises: [{ name: "Gainage", sets: 3, duration: 40, weight: 0, rest: 45, mode: "chrono" }],
      }),
    ],
  },
  {
    id: DEMO_CLIENT_IDS[7],
    name: "Paul Dupont",
    age: 39,
    emoji: "🧢",
    status: "active",
    objective: "Reprise sportive",
    constraints: "",
    disponibilites: "Sam 10h",
    niveau: "Débutant",
    preferences: "Progressif.",
    cancelCount: 0,
    tags: [],
    sessions: [
      _demoSession(1, 8, { id: DS.paul1, duration: 50, billableAmount: 60, summary: "Février — reprise." }),
      _demoSession(1, 22, { id: DS.paul2, duration: 50, billableAmount: 60, summary: "Février — renfo." }),
    ],
  },
];

function _weekDate(dayIndex) {
  const now = new Date();
  const dow = now.getDay();
  const monday = new Date(now);
  monday.setDate(now.getDate() - ((dow + 6) % 7));
  const target = new Date(monday);
  target.setDate(monday.getDate() + dayIndex);
  const y = target.getFullYear();
  const m = String(target.getMonth() + 1).padStart(2, "0");
  const dd = String(target.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

function _event(overrides) {
  const date = overrides.date || _weekDate(overrides.dayIndex ?? 0);
  const d = new Date(date + "T12:00:00");
  const day = `${DAYS[(d.getDay() + 6) % 7]} ${d.getDate()}`;
  return {
    date,
    day,
    duration: 60,
    type: "recurring",
    recurringGroupId: null,
    tarif: DEFAULT_TARIF,
    billable: false,
    ...overrides,
  };
}

function _padIsoD(d) {
  return String(d).padStart(2, "0");
}

/** Séances done / annulation / no-show (ISO) — alimente les KPIs engagement Revenus. */
function _demoFinanceMarchCalendar(y) {
  const rows = [];
  let mi = 0;
  const M = DEMO_FIN_MARCH_DONE_IDS;
  const pushDone = (day, clientIndex, name, time, dur, tarif = 60) => {
    rows.push(
      _event({
        id: M[mi++],
        date: `${y}-03-${_padIsoD(day)}`,
        time,
        clientId: DEMO_CLIENT_IDS[clientIndex],
        client: name,
        status: "done",
        type: "oneshot",
        recurringGroupId: null,
        duration: dur,
        tarif,
      }),
    );
  };
  [2, 4, 8, 10, 13, 15].forEach((d) => pushDone(d, 1, "Thomas Dubois", "09:00", 60));
  [3, 11, 16, 17, 19].forEach((d) => pushDone(d, 3, "Karim Benzari", "12:30", 40));
  [1, 12, 18].forEach((d) => pushDone(d, 0, "Sophie Martin", "07:30", 55));
  [6, 9, 14, 17].forEach((d) => pushDone(d, 2, "Marie Leclerc", "10:00", 45));
  [8, 12, 16, 20].forEach((d) => pushDone(d, 4, "Lucas Moreau", "07:00", 50, 50));
  [4, 13, 19].forEach((d) => pushDone(d, 5, "Julie Petit", "18:00", 50, 62));
  [7, 15, 23].forEach((d) => pushDone(d, 6, "Antoine Girard", "18:15", 55, 60));
  rows.push(
    _event({
      id: DE.finMarSophieCxl,
      date: `${y}-03-21`,
      time: "11:00",
      clientId: DEMO_CLIENT_IDS[0],
      client: "Sophie Martin",
      status: "cancelled",
      type: "oneshot",
      recurringGroupId: null,
      duration: 50,
      tarif: 60,
    }),
    _event({
      id: DE.finMarMarieNs,
      date: `${y}-03-22`,
      time: "10:30",
      clientId: DEMO_CLIENT_IDS[2],
      client: "Marie Leclerc",
      status: "cancelled",
      billable: true,
      type: "oneshot",
      recurringGroupId: null,
      duration: 45,
      tarif: 60,
    }),
  );
  return rows;
}

function _demoFinanceFebCalendar(y) {
  return [
    _event({
      id: DE.finFebLucas1,
      date: `${y}-02-${_padIsoD(11)}`,
      time: "07:00",
      clientId: DEMO_CLIENT_IDS[4],
      client: "Lucas Moreau",
      status: "done",
      type: "oneshot",
      recurringGroupId: null,
      duration: 50,
      tarif: 50,
    }),
    _event({
      id: DE.finFebPaul1,
      date: `${y}-02-${_padIsoD(8)}`,
      time: "16:00",
      clientId: DEMO_CLIENT_IDS[7],
      client: "Paul Dupont",
      status: "done",
      type: "oneshot",
      recurringGroupId: null,
      duration: 50,
      tarif: 60,
    }),
    _event({
      id: DE.finFebPaul2,
      date: `${y}-02-${_padIsoD(22)}`,
      time: "16:00",
      clientId: DEMO_CLIENT_IDS[7],
      client: "Paul Dupont",
      status: "done",
      type: "oneshot",
      recurringGroupId: null,
      duration: 50,
      tarif: 60,
    }),
  ];
}

function _initEventsDemoExtras() {
  const out = [];
  const n = new Date();
  const y0 = n.getFullYear();
  const mo0 = n.getMonth();
  const rot = [
    { clientIndex: 3, client: "Karim Benzari" },
    { clientIndex: 1, client: "Thomas Dubois" },
    { clientIndex: 5, client: "Julie Petit" },
    { clientIndex: 0, client: "Sophie Martin" },
  ];
  for (let i = 0; i < 5; i++) {
    const add = 2 + i * 2;
    const d = new Date(n);
    d.setDate(n.getDate() + add);
    if (d.getMonth() !== mo0 || d.getFullYear() !== y0) continue;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const date = `${y}-${m}-${dd}`;
    const r = rot[out.length % rot.length];
    out.push(
      _event({
        id: DEMO_DEMOPLAN_EVENT_IDS[out.length],
        date,
        time: `${11 + (out.length % 5)}:30`,
        clientId: DEMO_CLIENT_IDS[r.clientIndex],
        client: r.client,
        status: "scheduled",
        type: "oneshot",
        duration: 50,
        tarif: 60,
        recurringGroupId: null,
      }),
    );
  }
  return out;
}

export const INIT_EVENTS = [
  _event({ id: DE.e1, dayIndex: 0, time: "08:00", clientId: DEMO_CLIENT_IDS[0], client: "Sophie Martin", status: "scheduled", type: "recurring", recurringGroupId: DEMO_RG_SOPHIE, duration: 60, tarif: 60 }),
  _event({ id: DE.e2, dayIndex: 0, time: "10:00", clientId: DEMO_CLIENT_IDS[2], client: "Marie Leclerc", status: "scheduled", type: "recurring", recurringGroupId: DEMO_RG_MARIE, duration: 45, tarif: 60 }),
  _event({ id: DE.e3, dayIndex: 2, time: "08:00", clientId: DEMO_CLIENT_IDS[0], client: "Sophie Martin", status: "scheduled", type: "recurring", recurringGroupId: DEMO_RG_SOPHIE, duration: 60, tarif: 60 }),
  _event({ id: DE.e4, dayIndex: 2, time: "10:00", clientId: DEMO_CLIENT_IDS[2], client: "Marie Leclerc", status: "scheduled", type: "recurring", recurringGroupId: DEMO_RG_MARIE, duration: 45, tarif: 60 }),
  _event({ id: DE.e5, dayIndex: 2, time: "12:00", clientId: DEMO_CLIENT_IDS[3], client: "Karim Benzari", status: "scheduled", type: "oneshot", duration: 40, tarif: 60 }),
  _event({ id: DE.e6, dayIndex: 3, time: "18:30", clientId: DEMO_CLIENT_IDS[1], client: "Thomas Dubois", status: "scheduled", type: "recurring", recurringGroupId: DEMO_RG_THOMAS, duration: 60, tarif: 60 }),
  _event({ id: DE.e7, dayIndex: 4, time: "08:00", clientId: DEMO_CLIENT_IDS[0], client: "Sophie Martin", status: "scheduled", type: "recurring", recurringGroupId: DEMO_RG_SOPHIE, duration: 60, tarif: 60 }),
  _event({ id: DE.e8, dayIndex: 4, time: "12:00", clientId: DEMO_CLIENT_IDS[3], client: "Karim Benzari", status: "scheduled", type: "pack", duration: 35, tarif: 60 }),
  _event({ id: DE.e9, dayIndex: 5, time: "10:00", clientId: DEMO_CLIENT_IDS[1], client: "Thomas Dubois", status: "scheduled", type: "recurring", recurringGroupId: DEMO_RG_THOMAS, duration: 60, tarif: 60 }),
  ..._initEventsDemoExtras(),
  ..._demoFinanceMarchCalendar(DEMO_DATA_YEAR),
  ..._demoFinanceFebCalendar(DEMO_DATA_YEAR),
];

export const MONTH_NAMES_FR = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
];

export const MONTH_NAMES_SHORT = {
  "01": "janv", "02": "févr", "03": "mars", "04": "avr",
  "05": "mai", "06": "juin", "07": "juil", "08": "août",
  "09": "sept", "10": "oct", "11": "nov", "12": "déc",
};

export const DISCIPLINES = [
  { emoji: "💪", label: "Renforcement", desc: "Renforcement musculaire, gainage, travail postural" },
  { emoji: "🔥", label: "HIIT", desc: "Entraînement fractionné haute intensité, cardio explosif" },
  { emoji: "🧘", label: "Mobilité", desc: "Mobilité articulaire, stretching, récupération active" },
  { emoji: "🏋️", label: "Force", desc: "Développement de la force, charges lourdes, powerlifting" },
  { emoji: "🎯", label: "Sport-spécifique", desc: "Préparation physique adaptée à un sport précis" },
  { emoji: "🔄", label: "Remise en forme", desc: "Reprise d'activité, progression douce, condition physique générale" },
];

export const FORCE_EQUIPMENT = [
  { k: "bodyweight", l: "Poids du corps", always: true },
  { k: "dumbbells", l: "Haltères" },
  { k: "kettlebells", l: "Kettlebells" },
  { k: "barbell", l: "Barre + rack" },
  { k: "bands", l: "Élastiques" },
  { k: "machines", l: "Machines guidées" },
  { k: "trx", l: "TRX / sangles" },
];

export const CARDIO_EQUIPMENT = [
  { k: "cardioTapis", l: "Tapis de course" },
  { k: "cardioVelo", l: "Vélo / bike" },
  { k: "cardioRameur", l: "Rameur" },
  { k: "cardioSkiErg", l: "SkiErg" },
  { k: "cardioStep", l: "Step / escaliers" },
];
